export var CellStatusType;
(function (CellStatusType) {
    CellStatusType["normal"] = "normal";
    CellStatusType["disabled"] = "disabled";
    CellStatusType["selected"] = "selected";
    CellStatusType["current"] = "current";
    CellStatusType["range"] = "range";
    CellStatusType["begin"] = "begin";
    CellStatusType["end"] = "end";
    CellStatusType["today"] = "today";
})(CellStatusType || (CellStatusType = {}));
export var HeaderType;
(function (HeaderType) {
    HeaderType["select"] = "select";
    HeaderType["normal"] = "normal";
})(HeaderType || (HeaderType = {}));
